/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */
@layer properties;
.editor-content-plain {
  padding-inline: calc(var(--spacing, 0.25rem) * 4);
  padding-block: 0.3rem;
  font-size: var(--text-base, 1rem);
  line-height: var(--tw-leading, var(--text-base--line-height, calc(1.5 / 1)));
  --tw-leading: 1.75rem;
  line-height: 1.75rem;
  text-wrap: pretty;
  word-break: break-all;
  caret-color: hsl(var(--primary));
  &:focus-visible {
    --tw-outline-style: none;
    outline-style: none;
    @media (forced-colors: active) {
      outline: 2px solid transparent;
      outline-offset: 2px;
    }
  }
  & p {
    margin-block: 0px;
  }
}
@property --tw-leading {
  syntax: "*";
  inherits: false;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-leading: initial;
    }
  }
}
